$(document).ready(function () {
    $(document).on('click touchstart', '.like_img', function () {
        var $this = $(this);
        var todo = $(this).attr('todo');
        var topic_id = $(this).attr('topic_id');
        var section_id = $(this).attr('section_id');
        var catalog_id = $(this).attr('catalog_id');
        var trackingEventLabel = $(this).data('tracking-event-label');

        var ajax_url = '/topic_following/';
        var post_id = topic_id;


        if (section_id) {
            ajax_url = '/section_following/';
            post_id = section_id;
        }
        else if (catalog_id) {
            ajax_url = '/service_order/subscription_save/';
            post_id = catalog_id;
        }

        $.ajax({
                   url:     ajax_url,
                   data:    {
                       todo: todo,
                       id:   post_id
                   },
                   type:    'POST',
                   success: function (data) {
                       if (data == "401") {
                           location.href = '/authorization/';
                           return false;
                       }

                       var icon = '';
                       if (section_id) {
                           icon = '<span class="b-icon b-icon-club"></span><span class="b-icon b-icon-club_dismiss"></span><span class="b-icon b-icon-club_white"></span>';
                       }
                       else if (catalog_id) {
                           icon = '<span class="b-icon b-icon-club"></span><span class="b-icon b-icon-club_dismiss"></span><span class="b-icon b-icon-club_white"></span>';
                       }
                       else {
                           icon = '<span class="b-icon b-icon-bookmark"></span><span class="b-icon b-icon-club_dismiss"></span><span class="b-icon b-icon-bookmark_white"></span>';
                       }

                       if (todo == 'like') {
                           $this.attr('todo', 'unlike');

                           var
                               myClub = 'Ваш раздел',
                               clubOut = 'Отписаться от раздела',
                               myCatalog = 'Ваш раздел',
                               catalogOut = 'Отписаться от раздела',
                               subscribed = 'Вы подписаны на тему',
                               unsubscribe = 'Отписаться';

                           if (section_id) {
                               if ($this.hasClass('redbutton')) {
                                   $this.removeClass('redbutton redbutton-thread');
                                   $this.addClass('greybutton greybutton-in-club');
                                   $this.html('<em>' + myClub + '</em><i>' + clubOut + '</i>' + icon);
                               }
                               else {
                                   $this.find('[class*="_text"]').text(clubOut);
                               }
                               if ('undefined' !== typeof window.Tracker) {
                                   window.Tracker.pushEvent(
                                       {
                                           category: 'Subscription',
                                           action: 'Subscribe on section',
                                           label: trackingEventLabel,
                                           value: section_id
                                       }
                                   );
                               }
                           }
                           else if (catalog_id) {
                               if ($this.hasClass('redbutton')) {
                                   $this.removeClass('redbutton redbutton-thread');
                                   $this.addClass('greybutton greybutton-in-club');
                                   $this.html('<em>' + myCatalog + '</em><i>' + catalogOut + '</i>' + icon);
                               }
                               else {
                                   $this.find('[class*="_text"]').text(catalogOut);
                               }
                               if ('undefined' !== typeof window.Tracker) {
                                   window.Tracker.pushEvent(
                                       {
                                           category: 'Subscription',
                                           action: 'Subscribe on catalog',
                                           label: trackingEventLabel,
                                           value: catalog_id
                                       }
                                   );
                               }
                           }
                           else {
                               if ($this.hasClass('redbutton')) {
                                   $this.removeClass('redbutton redbutton-thread');
                                   $this.addClass('greybutton greybutton-thread');
                                   $this.html('<em>' + subscribed + '</em><i>' + unsubscribe + '</i>' + icon);
                               }
                               else {
                                   $this.find('[class*="_text"]').text(unsubscribe);
                                   $this.addClass('button_alt-active');
                               }
                               if ('undefined' !== typeof window.Tracker) {
                                   window.Tracker.pushEvent(
                                       {
                                           category: 'Subscription',
                                           action: 'Subscribe on topic',
                                           label: trackingEventLabel
                                       }
                                   );
                               }
                           }
                       }
                       else if (todo == 'unlike') {
                           $this.attr('todo', 'like');
                           if (section_id) {
                               if ($this.hasClass('greybutton')) {
                                   $this.removeClass('greybutton greybutton-thread greybutton-in-club');
                                   $this.addClass('redbutton redbutton-in-club');
                                   $this.html('Подписаться на раздел' + icon);
                               }
                               else {
                                   $this.find('[class*="_text"]').text('Подписаться <span class="layout__hidden-on-tablets">на раздел</span>');
                               }

                               if ('undefined' !== typeof window.Tracker) {
                                   window.Tracker.pushEvent(
                                       {
                                           category: 'Subscription',
                                           action: 'Unsubscribe from section',
                                           label: trackingEventLabel,
                                           value: section_id
                                       }
                                   );
                               }
                           }
                           else if (catalog_id) {
                               if ($this.hasClass('greybutton')) {
                                   $this.removeClass('greybutton greybutton-thread greybutton-in-club');
                                   $this.addClass('redbutton redbutton-in-club');
                                   $this.html('Подписаться на раздел' + icon);
                               }
                               else {
                                   $this.find('[class*="_text"]').text('Подписаться <span class="layout__hidden-on-tablets">на раздел</span>');
                               }

                               if ('undefined' !== typeof window.Tracker) {
                                   window.Tracker.pushEvent(
                                       {
                                           category: 'Subscription',
                                           action: 'Unsubscribe from catalog',
                                           label: trackingEventLabel,
                                           value: catalog_id
                                       }
                                   );
                               }
                           }
                           else {
                               if ($this.hasClass('greybutton')) {
                                   $this.removeClass('greybutton greybutton-thread greybutton-in-club');
                                   $this.addClass('redbutton redbutton-thread');
                                   $this.html(__('Подписаться на <span class="layout__hidden-on-tablets">на тему</span>') + icon);
                               }
                               else {
                                   $this.find('[class*="_text"]').html(__('Подписаться <span class="layout__hidden-on-tablets">на тему</span>'));
                                   $this.removeClass('button_alt-active');
                               }

                               if ('undefined' !== typeof window.Tracker) {
                                   window.Tracker.pushEvent(
                                       {
                                           category: 'Subscription',
                                           action: 'Unsubscribe from topic',
                                           label: trackingEventLabel
                                       }
                                   );
                               }
                           }
                       }

                       var eventName;
                       if (section_id || catalog_id) {
                           eventName = todo == 'like' ? 'forum_section_following' : 'forum_section_unfollowing';
                       }
                       else {
                           eventName = todo == 'like' ? 'forum_topic_following' : 'forum_topic_unfollowing';
                       }
                       $this.trigger(eventName, [post_id]);
                   }
               });
        return false;
    });
});